"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NO_US_NO_CHINA = exports.NO_CHINA = exports.NO_US = exports.APPROVE_VALUE = exports.BURN_ADDRESS = exports.BLOCKS_PER_YEAR = exports.BSC_BLOCK_TIME = exports.fetchIntervalsMs = exports.DEC_NORM = exports.ZERO_ADDRESS = exports.ZERO_BN = exports.DEFAULT_DATETIME_FORMAT = void 0;
var bn_js_1 = __importDefault(require("bn.js"));
var web3_utils_1 = require("web3-utils");
exports.DEFAULT_DATETIME_FORMAT = 'D MMM, HH:mm';
exports.ZERO_BN = new bn_js_1.default('0');
exports.ZERO_ADDRESS = '0x0000000000000000000000000000000000000000';
// Used to divide big numbers, like currency / tokens
exports.DEC_NORM = new bn_js_1.default('10').pow(new bn_js_1.default('18'));
exports.fetchIntervalsMs = {
    init: 60 * 1000,
    regular: 30 * 1000,
};
exports.BSC_BLOCK_TIME = 3;
exports.BLOCKS_PER_YEAR = new bn_js_1.default((60 / exports.BSC_BLOCK_TIME) * 60 * 24 * 365); // 10512000
exports.BURN_ADDRESS = '0x000000000000000000000000000000000000dEaD';
exports.APPROVE_VALUE = (0, web3_utils_1.toBN)((0, web3_utils_1.toWei)('1000000000000000000'));
exports.NO_US = ['US', 'AS', 'GU', 'MP', 'PR', 'UM', 'VI'];
exports.NO_CHINA = ['CN', 'HK', 'MO', 'TW'];
exports.NO_US_NO_CHINA = __spreadArray(__spreadArray([], exports.NO_US, true), exports.NO_CHINA, true);
